import i18n from '../i18n'

export const tooltipTexts = {
    deselectOne: i18n.t('report:tooltips.deselectOne'),
    deselectOneMore: i18n.t('report:tooltips.deselectOneMore'),
    deselectOneMoreWithoutMarker: i18n.t('report:tooltips.deselectOneMore'),
    selectOne: i18n.t('report:tooltips.selectOne'),
    selectOneMore: i18n.t('report:tooltips.selectOneMore'),
    final: i18n.t('report:tooltips.final')
}

export const statuses = [
    {
        id: 1,
        name: i18n.t('report:statuses.notStarted'),
        color: '79, 103, 194'
    },

    {
        id: 2,
        name: i18n.t('report:statuses.inProgress'),
        color: '36, 168, 246'
    },

    {
        id: 3,
        name: i18n.t('report:statuses.pendingApproval'),
        color: '0, 199, 220'
    },

    {
        id: 4,
        name: i18n.t('report:statuses.completed'),
        color: '155, 202, 92'
    },

    {
        id: 5,
        name: i18n.t('report:statuses.approved'),
        color: '0, 164, 154'
    },
];

export const users = [
    {
        id: 1,
        name: i18n.t('report:users.first'),
        tasks: [
            {status: 1, count: 2},
            {status: 2, count: 0},
            {status: 3, count: 1},
            {status: 4, count: 1},
            {status: 5, count: 2},
        ]
    },
    {
        id: 2,
        name: i18n.t('report:users.second'),
        tasks: [
            {status: 1, count: 1},
            {status: 2, count: 3},
            {status: 3, count: 2},
            {status: 4, count: 1},
            {status: 5, count: 0},
        ]
    },
    {
        id: 3,
        name: i18n.t('report:users.third'),
        tasks: [
            {status: 1, count: 0},
            {status: 2, count: 0},
            {status: 3, count: 1},
            {status: 4, count: 2},
            {status: 5, count: 3},
        ]
    },
    {
        id: 4,
        name: i18n.t('report:users.fourth'),
        tasks: [
            {status: 1, count: 1},
            {status: 2, count: 1},
            {status: 3, count: 2},
            {status: 4, count: 1},
            {status: 5, count: 2},
        ]
    }
]
